module.exports = __webpack_public_path__ + "static/media/DigitalContacts-logo.28d1cdee.svg";